import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const CONSENT_LS_KEY = 'dealer-user-consent';

export type userDetailsType = {
  broker: string;
  username: string;
};
export const useDealerUserConsent = create(
  persist(
    (set: any, get: any) => ({
      consent: false,
      setConsent: (consent: boolean) => set({ consent }),
    }),
    {
      name: CONSENT_LS_KEY, // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
